import { type IssueId, toIssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Item } from '@atlassian/jira-software-roadmap-timeline-table/src/common/types/item.tsx';
import { TIMELINE_PARENT_LEVEL } from '../constants.tsx';

export const SKELETON_ITEM_PREFIX = 'SKELETON-ITEM-';

export const isItemSkeleton = (issueId: IssueId) =>
	String(issueId).startsWith(SKELETON_ITEM_PREFIX);

export const createItemSkeleton = ({
	id,
	level,
}: {
	id: string;
	level: number;
}): {
	id: string;
	level: number;
} => ({
	id: toIssueId(`${SKELETON_ITEM_PREFIX}${id}`),
	level,
});

// Dummy "items" that are being used in timeline-table while real data is loading
export const LOADING_ITEMS: Item[] = Array.from({ length: 20 }, (_, i) => ({
	id: toIssueId(`${SKELETON_ITEM_PREFIX}${i}`),
	level: TIMELINE_PARENT_LEVEL,
	isInTransition: false,
	childItems: undefined,
}));
